import { HarvestProofPhotoExif } from '@harvest-proof/data-access';

export function formatPhotoExifSummary(
  exif: HarvestProofPhotoExif | null | undefined,
): string | null {
  if (!exif) {
    return null;
  }

  const parts: string[] = [];

  if (exif.datetime_original) {
    parts.push(`Date photo : ${exif.datetime_original}`);
  }

  if (exif.make || exif.model) {
    parts.push(`Appareil : ${[exif.make, exif.model].filter(Boolean).join(' ')}`);
  }

  const photoGps = exif.gps;
  if (photoGps?.latitude != null && photoGps?.longitude != null) {
    parts.push(
      `GPS photo : ${photoGps.latitude.toFixed(5)}, ${photoGps.longitude.toFixed(5)}`,
    );
  }

  const captureGps = exif.capture_gps;
  if (
    parts.length === 0 &&
    captureGps?.latitude != null &&
    captureGps?.longitude != null
  ) {
    parts.push(
      `GPS à l’envoi : ${captureGps.latitude.toFixed(5)}, ${captureGps.longitude.toFixed(5)}`,
    );
  }

  if (parts.length > 0) {
    return parts.join(' · ');
  }

  if (exif.missing) {
    return 'Métadonnées photo non disponibles (GPS navigateur enregistré à part)';
  }

  return null;
}
